'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _mapValues = require('lodash/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

var _utils = require('./utils');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuerySet = function () {
    function QuerySet(modelClass, clauses, opts) {
        (0, _classCallCheck3.default)(this, QuerySet);

        (0, _assign2.default)(this, {
            modelClass: modelClass,
            clauses: clauses || []
        });

        this._opts = opts;
    }

    QuerySet.addSharedMethod = function addSharedMethod(methodName) {
        this.sharedMethods = this.sharedMethods.concat(methodName);
    };

    QuerySet.prototype._new = function _new(clauses, userOpts) {
        var opts = (0, _assign2.default)({}, this._opts, userOpts);
        return new this.constructor(this.modelClass, clauses, opts);
    };

    QuerySet.prototype.toString = function toString() {
        var _this = this;

        this._evaluate();
        var contents = this.rows.map(function (id) {
            return _this.modelClass.withId(id).toString();
        }).join('\n    - ');
        return 'QuerySet contents: \n    - ' + contents;
    };

    QuerySet.prototype.toRefArray = function toRefArray() {
        this._evaluate();
        return this.rows;
    };

    QuerySet.prototype.toModelArray = function toModelArray() {
        this._evaluate();
        var ModelClass = this.modelClass;
        return this.rows.map(function (props) {
            return new ModelClass(props);
        });
    };

    QuerySet.prototype.count = function count() {
        this._evaluate();
        return this.rows.length;
    };

    QuerySet.prototype.exists = function exists() {
        return Boolean(this.count());
    };

    QuerySet.prototype.at = function at(index) {
        this._evaluate();
        if (index >= 0 && index < this.rows.length) {
            var ModelClass = this.modelClass;
            return new ModelClass(this.rows[index]);
        }

        return undefined;
    };

    QuerySet.prototype.first = function first() {
        return this.at(0);
    };

    QuerySet.prototype.last = function last() {
        this._evaluate();
        return this.at(this.rows.length - 1);
    };

    QuerySet.prototype.all = function all() {
        return this._new(this.clauses);
    };

    QuerySet.prototype.filter = function filter(lookupObj) {
        var normalizedLookupObj = (typeof lookupObj === 'undefined' ? 'undefined' : (0, _typeof3.default)(lookupObj)) === 'object' ? (0, _mapValues2.default)(lookupObj, _utils.normalizeEntity) : lookupObj;
        var filterDescriptor = { type: _constants.FILTER, payload: normalizedLookupObj };
        return this._new(this.clauses.concat(filterDescriptor));
    };

    QuerySet.prototype.exclude = function exclude(lookupObj) {
        var normalizedLookupObj = (typeof lookupObj === 'undefined' ? 'undefined' : (0, _typeof3.default)(lookupObj)) === 'object' ? (0, _mapValues2.default)(lookupObj, _utils.normalizeEntity) : lookupObj;
        var excludeDescriptor = { type: _constants.EXCLUDE, payload: normalizedLookupObj };
        return this._new(this.clauses.concat(excludeDescriptor));
    };

    QuerySet.prototype._evaluate = function _evaluate() {
        if (!this._evaluated) {
            var session = this.modelClass.session;

            var querySpec = {
                table: this.modelClass.modelName,
                clauses: this.clauses
            };

            var _session$query = session.query(querySpec),
                rows = _session$query.rows;

            this.rows = rows;
            this._evaluated = true;
        }
    };

    QuerySet.prototype.orderBy = function orderBy(iteratees, orders) {
        var orderByDescriptor = { type: _constants.ORDER_BY, payload: [iteratees, orders] };
        return this._new(this.clauses.concat(orderByDescriptor));
    };

    QuerySet.prototype.update = function update(mergeObj) {
        this.modelClass.session.applyUpdate({
            action: _constants.UPDATE,
            query: {
                table: this.modelClass.modelName,
                clauses: this.clauses
            },
            payload: mergeObj
        });
        this._evaluated = false;
    };

    QuerySet.prototype.delete = function _delete() {
        this.toModelArray().forEach(function (model) {
            return model._onDelete();
        });

        this.modelClass.session.applyUpdate({
            action: _constants.DELETE,
            query: {
                table: this.modelClass.modelName,
                clauses: this.clauses
            }
        });

        this._evaluated = false;
    };

    QuerySet.prototype.map = function map() {
        throw new Error('QuerySet.prototype.map is removed. ' + 'Call .toModelArray() or .toRefArray() first to map.');
    };

    QuerySet.prototype.forEach = function forEach() {
        throw new Error('QuerySet.prototype.forEach is removed. ' + 'Call .toModelArray() or .toRefArray() first to iterate.');
    };

    (0, _createClass3.default)(QuerySet, [{
        key: 'withModels',
        get: function get() {
            throw new Error('QuerySet.prototype.withModels is removed. ' + 'Use .toModelArray() or predicate functions that ' + 'instantiate Models from refs, e.g. new Model(ref).');
        }
    }, {
        key: 'withRefs',
        get: function get() {
            (0, _utils.warnDeprecated)('QuerySet.prototype.withRefs is deprecated. ' + 'Query building operates on refs only now.');
            return undefined;
        }
    }]);
    return QuerySet;
}();

QuerySet.sharedMethods = ['count', 'at', 'all', 'last', 'first', 'exists', 'filter', 'exclude', 'orderBy', 'update', 'delete'];

exports.default = QuerySet;